import { useContext } from "react";
import { CustomTimePiker } from "../../../../../../components";
import "./index.scss";
import Context from "../../../../../../context";
import utils from "../../../../../../utils";
import Cookies from "js-cookie";
import constants from "../../../../../../values/constants";
import { useTranslation } from "react-i18next";

const TimeFilter = () => {
  const { requestDriverTransaction, setRequestDriverTransaction } = useContext(
    Context.DriverTransactionScreen
  );
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  const { t } = useTranslation();

  return (
    <div className="time-filter-container">
      <label className="time-filter-item">
        از تاریخ
        <CustomTimePiker
          placeholder="تاریخ شروع"
          defaultValue={
            requestDriverTransaction.startAt &&
            requestDriverTransaction.startAt
          }
          onChange={(event) =>
            setRequestDriverTransaction({
              ...requestDriverTransaction,
              startAt:  event ,
            })
          }
        />
      </label>
      <label className="time-filter-item">
        تا تاریخ
        <CustomTimePiker
          placeholder="تاریخ پایان"
          defaultValue={
            requestDriverTransaction.endAt &&
            requestDriverTransaction.endAt
          }
          onChange={(event) =>
            setRequestDriverTransaction({
              ...requestDriverTransaction,
              endAt:  event,
            })
          }
        />
      </label>
    </div>
  );
};

export default TimeFilter;
